import { Provider } from '../types'
import { EnrichComponent } from './common/enrichcomponent'

class EnrichPoints extends EnrichComponent {
  constructor() {
    super(
      {
        name: 'native.enrichpoints',
        group: 'Data Enrichment',
        title: 'Enrich Points',
        description: `
      This uses a data source (either a table or a DO subscription) to enrich another target table.
      `,
        starred: true
      },
      'ENRICH_POINTS'
    )

    // adapt the input descriptions to the specific command geo type
    let index = this.inputs.findIndex((i) => i.name === 'target')
    this.inputs[index].description = this.inputs[index].title = 'Target points to be enriched'

    index = this.inputs.findIndex((i) => i.name === 'target_col')
    this.inputs[index].description = this.inputs[index].title = 'Target point geo column'
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Redshift, Provider.Snowflake]
  }
}

export { EnrichPoints }
